import { clsx } from 'clsx'
import { Building2, Briefcase, HardHat, ShieldCheck } from 'lucide-react'

/**
 * Compliance-domain "logo cloud" — uses monoline lucide icons for the four
 * buyer categories rather than fake customer logos (Master Architecture
 * Decision 4 + homepage Section 2). The "Designed for compliance teams in"
 * heading is supplied by the page.
 */
const categories = [
  { icon: Building2, label: 'Property Management' },
  { icon: Briefcase, label: 'Real Estate Operations' },
  { icon: HardHat, label: 'Construction & Capital Projects' },
  { icon: ShieldCheck, label: 'Risk & Compliance Teams' },
]

export function LogoCloud({
  className,
}: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className={clsx(
        className,
        'grid grid-cols-2 gap-x-8 gap-y-10 sm:grid-cols-4',
      )}
    >
      {categories.map(({ icon: Icon, label }) => (
        <div
          key={label}
          className="flex flex-col items-center gap-3 text-center transition hover:opacity-100 sm:opacity-80"
        >
          <Icon
            className="size-8 text-gray-400"
            strokeWidth={1.5}
            aria-hidden="true"
          />
          <span className="text-sm font-medium text-gray-500">{label}</span>
        </div>
      ))}
    </div>
  )
}
